/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Otp_LabelInputs */

const es_ab_otp_label = /** @type {(inputs: Ab_Otp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de verificación`)
};

const gl_ab_otp_label = /** @type {(inputs: Ab_Otp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de verificación`)
};

const en_ab_otp_label = /** @type {(inputs: Ab_Otp_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verification code`)
};

/**
* | output |
* | --- |
* | "Verification code" |
*
* @param {Ab_Otp_LabelInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_otp_label = /** @type {((inputs?: Ab_Otp_LabelInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Otp_LabelInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_otp_label(inputs)
	if (locale === "en") return en_ab_otp_label(inputs)
	return es_ab_otp_label(inputs)
});